import inscriptionService from "@/services/inscription";
export default {
  data() {
    return {
      loading: false,
      emailConfirmationAlert: {},
      email: "",
      loadingResendingEmail: false,
    };
  },
  methods: {
    resendConfirmationEmail() {
      const vue = this;
      vue.loadingResendingEmail = true;
      inscriptionService
        .sendConfirmationEmail({
          email: vue.email,
        })
        .then(function(response) {
          vue.emailConfirmationAlert.message = response.message;
          if (response.success) {
            vue.emailConfirmationAlert.variant = "success";
          } else {
            vue.emailConfirmationAlert.variant = "danger";
          }
          vue.emailConfirmationAlert.show = true;
        })
        .catch(function(error) {
          // handle error
          vue.emailConfirmationAlert.message = error.message;
          vue.emailConfirmationAlert.variant = "danger";
          vue.emailConfirmationAlert.show = true;
        })
        .finally(function() {
          vue.loadingResendingEmail = false;
        });
    },
  },
};
